import { translationLanguages } from "../utils/translationLanguages";
import { IoEarth } from "react-icons/io5";
import { Dropdown } from "antd";
import { useLanguageStore } from "../../stores/languageStore";

export const LanguageTranslator = ({ iconColor = "white" }) => {
  const setLang = useLanguageStore((state) => state.setLang);

  const handleLanguageChange = (lang) => {
    const value = lang.code;
    setLang(value);

    const gtCombo = document.querySelector(".goog-te-combo");
    if (gtCombo) {
      gtCombo.value = value;
      gtCombo.dispatchEvent(new Event("change"));
    }
  };

  const menuItems = translationLanguages.map((lang) => ({
    key: lang.code,
    label: (
      <div
        className="flex items-center gap-[5px] cursor-pointer"
        onClick={() => handleLanguageChange(lang)}
      >
        <div
          className="w-[30px] h-[25px] bg-no-repeat bg-center bg-cover shrink-0"
          style={{
            backgroundImage: `url(https://cdn.weglot.com/flags/square/${lang.flag}.svg)`,
          }}
        />
        <span className="text-2xl">{lang.name}</span>
      </div>
    ),
  }));

  return (
    <Dropdown
      menu={{ items: menuItems }}
      placement="bottomRight"
      trigger={["hover"]}
    >
      <button
        className={`flex items-center justify-center p-0 border-0 cursor-pointer rounded-full bg-transparent transition-colors ${
          iconColor === "white" ? "text-white" : "text-black"
        }`}
      >
        <IoEarth className="w-8 h-8 md:w-10 md:h-10" />
      </button>
    </Dropdown>
  );
};
